// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__vxq02","col":"styles_col__2UwVE"};